module.exports = __webpack_public_path__ + "img/push-fei-title.89beb39d.png";